(function () {
  const KEY = 'wishlist_items_v1';
  const HOVER_MS = 500;
  const TOAST_MS = 4000;

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch { return []; }
  }
  function save(ids) { localStorage.setItem(KEY, JSON.stringify(ids)); }

  function bindWishlist(root) {
    const ids = new Set(load());
    root.querySelectorAll('[data-wishlist-toggle]:not([data-wl-bound])').forEach(btn => {
      btn.setAttribute('data-wl-bound', '1');
      const id = String(btn.dataset.productId);
      const active = ids.has(id);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');

      btn.addEventListener('click', () => {
        const nowActive = !btn.classList.contains('is-active');
        if (nowActive) ids.add(id); else ids.delete(id);
        save([...ids]);
        // a product can appear in more than one grid on the same page
        // (e.g. Best Sellers and You may also like) - keep every instance in sync
        document.querySelectorAll('[data-wishlist-toggle][data-product-id="' + id + '"]').forEach(b => {
          b.classList.toggle('is-active', nowActive);
          b.setAttribute('aria-pressed', nowActive ? 'true' : 'false');
        });
        document.dispatchEvent(new CustomEvent('wishlist:update', { detail: { ids: [...ids] } }));
      });
    });
  }

  // Dawn's header (sections/header.liquid) wraps the whole count bubble in
  // {% if cart != empty %}, so on a cart that started the page empty, the
  // element genuinely doesn't exist yet - querySelector finds nothing and a
  // plain textContent update silently does nothing. Build it the first time
  // it's needed, matching Dawn's own markup/classes exactly.
  function updateCartBubble(count) {
    const anchor = document.getElementById('cart-icon-bubble');
    if (!anchor) return;
    let bubble = anchor.querySelector('.cart-count-bubble');
    if (count <= 0) {
      if (bubble) bubble.remove();
      return;
    }
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      anchor.appendChild(bubble);
    }
    const label = count === 1 ? '1 item' : count + ' items';
    bubble.innerHTML =
      (count < 100 ? '<span aria-hidden="true">' + count + '</span>' : '') +
      '<span class="visually-hidden">' + label + '</span>';
  }

  let toastEl = null;
  let toastTimer = null;

  function showAddedToast(item) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'atc-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }

    const qtyText = item.quantity > 1 ? ' × ' + item.quantity : '';
    toastEl.innerHTML =
      (item.image
        ? '<img class="atc-toast__img" src="' + item.image.replace('{width}', '120') + '" alt="" width="48" height="48">'
        : '') +
      '<div class="atc-toast__body">' +
        '<p class="atc-toast__title">Added to cart</p>' +
        '<p class="atc-toast__product">' + item.product_title.replace(/</g, '&lt;') + qtyText + '</p>' +
      '</div>' +
      '<a class="atc-toast__link" href="/cart">View cart</a>' +
      '<button type="button" class="atc-toast__close" aria-label="Dismiss">&times;</button>';

    toastEl.querySelector('.atc-toast__close').addEventListener('click', hideToast);

    // requestAnimationFrame can be throttled or fully suspended when the
    // tab/pane isn't actively compositing frames, which left this stuck at
    // opacity:0 - a plain timeout has no such dependency.
    clearTimeout(toastEl._showTimer);
    toastEl._showTimer = setTimeout(() => toastEl.classList.add('is-visible'), 10);
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, TOAST_MS);
  }

  function hideToast() {
    clearTimeout(toastTimer);
    if (toastEl) toastEl.classList.remove('is-visible');
  }

  function bindAjaxCart(root) {
    root.querySelectorAll('form[data-ajax-add]:not([data-ac-bound])').forEach(form => {
      form.setAttribute('data-ac-bound', '1');
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const fd = new FormData(form);
        const btn = form.querySelector('button');
        btn.disabled = true;
        try {
          const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd });
          if (!res.ok) throw new Error('add failed');
          const item = await res.json();
          btn.classList.add('added');
          showAddedToast(item);
          try {
            const cart = await (await fetch('/cart.js')).json();
            updateCartBubble(cart.item_count);
          } catch {}
        } catch (err) {
          console.error(err);
          btn.classList.add('error');
        } finally {
          btn.disabled = false;
          setTimeout(() => btn.classList.remove('added', 'error'), 1500);
        }
      });
    });
  }

  // Cycles the images inside [data-pc-media] (the shared product-card
  // snippet) on hover / keyboard focus. Shared by every card grid on the
  // site instead of each section shipping its own copy.
  function bindHoverMedia(root) {
    root.querySelectorAll('[data-pc-media]:not([data-hm-bound])').forEach(media => {
      media.setAttribute('data-hm-bound', '1');
      let imgs = media.querySelectorAll('.pc-img');
      const hoverImages = media.querySelector('[data-pc-hover-images]');
      if (imgs.length < 2 && !hoverImages) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      let i = 0, timer = null;
      function show(n) {
        const next = (n + imgs.length) % imgs.length;
        if (!imgs[next].complete || !imgs[next].naturalWidth) return;
        imgs[i].classList.remove('is-active');
        i = next;
        imgs[i].classList.add('is-active');
      }
      function start() {
        if (hoverImages && hoverImages.isConnected) {
          media.appendChild(hoverImages.content.cloneNode(true));
          hoverImages.remove();
          imgs = media.querySelectorAll('.pc-img');
        }
        if (!timer) timer = setInterval(() => show(i + 1), HOVER_MS);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } show(0); }

      media.addEventListener('mouseenter', start);
      media.addEventListener('mouseleave', stop);
      media.addEventListener('focusin', start);
      media.addEventListener('focusout', stop);
    });
  }

  function bindAll(root) {
    bindWishlist(root);
    bindAjaxCart(root);
    bindHoverMedia(root);
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindAll(document);

    // Re-bind whenever new cards enter the page. Dawn's own facet filtering
    // replaces #ProductGridContainer's innerHTML on every sort/filter change,
    // and the "You may also like" section fetches and swaps in its markup
    // after load - without this, hearts and Add to Cart on anything injected
    // post-load would stay inert (bindWishlist/bindAjaxCart only ever ran once).
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          bindAll(node);
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
